import TextAreaInput from "./TextAreaInput"
import TextInput from "./TextInput"
import NumberInput from "./NumberInput"
import DecimalInput from "./DecimalInput"
import SelectInput from "./SelectInput"
import RichTextInput from "./RichTextInput"
import DollarFieldWithLabel from "./DollarFieldWithLabel"
import PercentFieldWithLabel from "../../PercentFieldWithLabel"
import CheckboxInput from "./CheckboxInput"

const Form = {
  NumberInput,
  DecimalInput,
  RichTextInput,
  SelectInput,
  TextAreaInput,
  TextInput,
  CheckboxInput,
  DollarFieldWithLabel,
  PercentFieldWithLabel,
}

export default Form
